import { Text } from "@mantine/core";
import BankAccountFields from "pages/Debt/components/BankAccountFields/BankAccountFields";
import { emptyBankAccount } from "pages/Debt/components/BankAccountFields/config";
import { BulkReceiptPaymentFormValues } from "pages/Debt/components/BulkReceiptCreateForm/config";
import { FormikProps } from "formik";
import { useListBankAccount } from "utils/hooks/request/useBankAccount";

interface BulkReceiptPaymentStepProps {
  formik: FormikProps<BulkReceiptPaymentFormValues>;
  /** Số phiếu thu đã nhập ở bước 1, chỉ để hiển thị cho người dùng biết áp dụng cho bao nhiêu phiếu. */
  receiptCount: number;
}

/**
 * Nội dung bước 2: chọn phương thức thanh toán MỘT LẦN cho toàn bộ lô phiếu
 * thu đã nhập ở bước 1, thay vì lặp lại trên từng dòng.
 */
const BulkReceiptPaymentStep = ({ formik, receiptCount }: BulkReceiptPaymentStepProps) => {
  const { bankAccountList, bankAccountOptions, isLoading: isLoadingBankAccounts } =
    useListBankAccount();

  return (
    <>
      <Text size="sm" c="dimmed">
        Phương thức thanh toán này sẽ được áp dụng cho toàn bộ {receiptCount} phiếu
        thu đã nhập ở bước trước.
      </Text>

      <BankAccountFields
        paymentMethod={formik.values.paymentMethod}
        onPaymentMethodChange={(method) => {
          formik.setFieldValue("paymentMethod", method);
          if (method === "cash") {
            formik.setFieldValue("bankAccount", emptyBankAccount());
          }
        }}
        value={formik.values.bankAccount}
        onChange={(next) => formik.setFieldValue("bankAccount", next)}
        onFieldBlur={(field) => formik.setFieldTouched(`bankAccount.${field}`, true)}
        errors={
          typeof formik.errors.bankAccount === "object"
            ? formik.errors.bankAccount
            : undefined
        }
        touched={
          typeof formik.touched.bankAccount === "object"
            ? formik.touched.bankAccount
            : undefined
        }
        bankAccountList={bankAccountList}
        bankAccountOptions={bankAccountOptions}
        isLoadingBankAccounts={isLoadingBankAccounts}
        showLabel={false}
      />
    </>
  );
};

export default BulkReceiptPaymentStep;
